import { Component, inject, input } from '@angular/core';
import { MatIconButton } from '@angular/material/button';
import {
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle,
} from '@angular/material/dialog';

import { MatIcon } from '@angular/material/icon';
import { ModalResponseEnum } from '@shared/enums/modal-response.enum';

@Component({
  selector: 'app-common-modal',
  imports: [
    MatDialogTitle,
    MatDialogContent,
    MatDialogActions,
    MatDialogClose,
    MatIconButton,
    MatIcon,
  ],
  templateUrl: './common-modal.component.html',
  styleUrl: './common-modal.component.scss',
})
export class CommonModalComponent {
  private dialogRef = inject(MatDialogRef);

  alignTitleCenter = input(true);

  modalDialogClosed() {
    this.dialogRef.close({ event: ModalResponseEnum.CANCEL });
  }
}
